// store/index.js
import {createStore} from 'vuex'

// Store Modules
import contracts from './modules/contracts'
import subscriptions from './modules/subscriptions'
import routeOptimization from './modules/routeOptimization'

const state = {
    token: '',
    geoDataToken: '',
    geoDataMapToken: '',
    mapKey: '',
    mapEnv: '',
    copiedGeometries: null,
    mapSettings: {},
    mapZoomLevel: null,
    initialized: false
}

const mutations = {
    storeCopiedGeometries(state, value) {
        state.copiedGeometries = value
    },
    storeToken(state, value) {
        state.token = value
    },
    storeGeoDataToken(state, value) {
        state.geoDataToken = value
    },
    storeGeoDataMapToken(state, value) {
        state.geoDataMapToken = value
    },
    storeMapKey(state, value) {
        state.mapKey = value
    },
    storeMapEnv(state, value) {
        state.mapEnv = value
    },
    storeMapSettings(state, value) {
        state.mapSettings = {
            ...state.mapSettings,
            ...value,
        }
    },
    storeMapZoomLevel(state, value) {
        state.mapZoomLevel = value
    },
    storeInitialized(state, value) {
        state.initialized = value
    }
}

export default createStore({
    modules: {
        contracts,
        subscriptions,
        routeOptimization
    },
    state,
    mutations,
})
